/* GRIPXX · The scrub engine */

(function () {
  'use strict';

  var LIBS = [
    { url: 'https://cdn.jsdelivr.net/npm/gsap@3.13.0/dist/gsap.min.js',
      sri: 'sha384-HOvlOYPIs/zjoIkWUGXkVmXsjr8GuZLV+Q+rcPwmJOVZVpvTSXQChiN4t9Euv9Vc' },
    { url: 'https://cdn.jsdelivr.net/npm/gsap@3.13.0/dist/ScrollTrigger.min.js',
      sri: 'sha384-P8VzCVnT9NBUkMrpcIZrJbA7EBjJvh/fJS6PmP+4nLIM284DtsImIv8D0fFjIkeh' },
    { url: 'https://cdn.jsdelivr.net/npm/lenis@1.3.11/dist/lenis.min.js',
      sri: 'sha384-kdY9hFBPoAPpxcrLihsO3APivFOxtQwSeYdzFD5CIIfLurwhdMrEHhkQxZJDkxgk' }
  ];

  /* damping */

  var LAMBDA = 9;

  function damp(current, target, dtMs) {
    var dt = Math.min(dtMs, 64) / 1000;
    return current + (target - current) * (1 - Math.exp(-LAMBDA * dt));
  }

  var root = document.documentElement;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var small = window.matchMedia('(max-width: 760px)');

  function wantsSequence() {
    return small.matches ||
      /iP(hone|ad|od)/.test(navigator.platform) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  }

  /* loading */

  function load(lib) {
    return new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = lib.url;
      s.async = false;                      /* parallel download, in-order execution */
      if (lib.sri) { s.integrity = lib.sri; s.crossOrigin = 'anonymous'; }
      s.onload = resolve;
      s.onerror = function () { reject(new Error(lib.url)); };
      document.head.appendChild(s);
    });
  }

  /* hero */

  function loops() {
    var vids = [].slice.call(
      document.querySelectorAll('[data-gx-hero], [data-gx-loop]'));
    if (!vids.length) return;

    if (reduced.matches) {
      vids.forEach(function (v) { v.pause(); });
      return;                       /* posters stand; nothing is lost */
    }

    var paused = false;
    var onScreen = [];

    function play(v) {
      if (paused) return;
      var p = v.play();
      /* Autoplay can still be refused by policy. The poster is already
         the fallback, so there is nothing to repair — just do not throw. */
      if (p && p.catch) { p.catch(function () {}); }
    }

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'gx-motion-toggle';
    btn.setAttribute('aria-pressed', 'false');
    btn.hidden = true;
    var label = function () {
      btn.textContent = paused ? 'Play motion' : 'Pause motion';
      btn.setAttribute('aria-pressed', String(paused));
    };
    label();
    btn.addEventListener('click', function () {
      paused = !paused;
      vids.forEach(function (v) { if (paused) { v.pause(); } else if (onScreen.indexOf(v) > -1) { play(v); } });
      label();
    });
    document.body.appendChild(btn);

    vids.forEach(function (v) {
      v.preload = 'auto';

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            var i = onScreen.indexOf(v);
            if (e.isIntersecting) {
              if (i < 0) { onScreen.push(v); }
              play(v);
            } else {
              if (i > -1) { onScreen.splice(i, 1); }
              v.pause();
            }
          });
          btn.hidden = onScreen.length === 0;
        }, { threshold: 0.05 }).observe(v);
      } else {
        onScreen.push(v);
        play(v);
        btn.hidden = false;
      }
    });
  }

  /* entrance */

  function entrance() {
    var hero = document.querySelector('.gx-hero');
    if (!hero || reduced.matches) return;

    root.classList.add('gx-enter');

    var release = function () { root.classList.add('gx-entered'); };
    requestAnimationFrame(function () { requestAnimationFrame(release); });
    setTimeout(release, 400);
  }

  /* stuck bar */

  var readStuck = null;

  function stickyBar() {
    var head = document.querySelector('.head');
    if (!head) return;
    var on = false;
    readStuck = function () {
      var next = (window.scrollY || document.documentElement.scrollTop || 0) > 24;
      if (next === on) return;
      on = next;
      head.classList.toggle('is-stuck', on);
    };

    window.addEventListener('scroll', readStuck, { passive: true });
    readStuck();
  }

  function boot() {
    entrance();
    stickyBar();

    /* These run regardless of what follows — reduced motion and a
       blocked CDN both still get a correct hero and a correct bed. */
    loops();

    /* Reduced motion never loads the libraries at all. Downloading
       130KB to then honour a preference not to use it is waste. */
    if (reduced.matches) return;

    Promise.all(LIBS.map(load))
      .then(start)
      .catch(function (err) {
        /* Fail closed and say so. A silent failure here looks identical
           to a design decision, which is how it survives to production. */
        if (window.console) {
          console.warn('GRIPXX: scroll libraries unavailable, staying in ' +
                       'static mode. Failed on ' + err.message);
        }
      });
  }

  /* start */

  function start() {
    if (!window.gsap || !window.ScrollTrigger || !window.Lenis) {
      throw new Error('a library loaded but did not register');
    }
    gsap.registerPlugin(ScrollTrigger);

    /* Order matters. The class changes every act from `height: auto` to
       400svh, so ScrollTrigger must not measure until after it lands. */
    root.classList.add('gx-ready');

    var lenis = new Lenis({
      lerp: 0.12,
      wheelMultiplier: 1,
      smoothWheel: true,
      anchors: true
    });

    /* Exposed so anything else on the page scrolls through the same
       instance rather than fighting it with window.scrollTo. */
    window.gripxxLenis = lenis;

    gsap.ticker.add(function (time) {
      lenis.raf(time * 1000);
      ScrollTrigger.update();

      if (readStuck) { readStuck(); }
    });
    gsap.ticker.lagSmoothing(0);

    var acts = [].slice.call(document.querySelectorAll('[data-gx-act]')).map(setupAct);

    /* One ticker for every act. Per-act rAF loops would multiply the
       seek cost by the number of films on the page. */
    gsap.ticker.add(function (time, dt) {
      acts.forEach(function (a) { a.tick(dt); });
    });

    reveals();
    theLine();
    magnetic();
    rail();
    buyBar();

    ScrollTrigger.refresh();
  }

  /* act */

  function setupAct(section) {

    [].slice.call(section.querySelectorAll('[data-gx-callout]')).forEach(function (c) {
      if (c.querySelector('.gx-callout__lead')) return;
      var lead = document.createElement('span');
      lead.className = 'gx-callout__lead';
      lead.setAttribute('aria-hidden', 'true');
      c.appendChild(lead);
    });

    var video = section.querySelector('[data-gx-film]');
    var canvas = section.querySelector('[data-gx-canvas]');
    var bar = section.querySelector('[data-gx-prog] i');
    var beats = [].slice.call(section.querySelectorAll('[data-gx-at]'));
    var callouts = [].slice.call(section.querySelectorAll('[data-gx-callout]'));
    var calloutAt = callouts.map(function (el) { return parseFloat(el.getAttribute('data-gx-callout')); });
    var calloutOn = callouts.map(function () { return null; });

    var state = {
      target: 0,     /* where the scrollbar says we are, 0..1 */
      current: 0,    /* where the film actually is — chases target */
      duration: 0,
      ready: false,  /* true only once real frame data exists to seek into */
      frames: null,  /* Image[] when running the sequence path */
      ctx: null,
      live: -1,
      lastSeek: -1   /* seconds; throttles requests at the decoder */
    };

    var src = video && video.getAttribute('data-gx-src');
    var seq = video && video.getAttribute('data-gx-seq');
    var seqN = parseInt(video && video.getAttribute('data-gx-seq-frames'), 10) || 0;

    function attach() {
      if (seq && seqN && wantsSequence()) {
        loadSequence(seq, seqN, video, canvas, state);
      } else if (src) {
        attachVideo();
      }
    }

    function attachVideo() {
      video.preload = 'auto';
      video.src = src;
      video.load();

      /* Probe one seek before scrubbing: a server without byte-range
         support (e.g. the theme dev proxy) snaps every seek back to 0.
         Then the frame sequence takes over so the act still moves. */
      video.addEventListener('loadeddata', function () {
        state.duration = video.duration || 0;
        var probe = Math.min(1, state.duration / 2);
        video.currentTime = probe;
        setTimeout(function () {
          if (video.currentTime < probe / 2 && seq && seqN) {
            video.removeAttribute('src');
            video.load();
            loadSequence(seq, seqN, video, canvas, state);
            return;
          }
          state.ready = true;
          state.dirty = true;
        }, 900);
      }, { once: true });

      var primed = false;
      var prime = function () {
        if (primed) return;
        primed = true;
        var p = video.play();
        if (p && p.then) { p.then(function () { video.pause(); }, function () {}); }
        else { video.pause(); }
      };
      ['pointerdown', 'wheel', 'keydown', 'touchstart'].forEach(function (evt) {
        window.addEventListener(evt, prime, { once: true, passive: true });
      });
    }

    if (src || (seq && seqN)) {
      ScrollTrigger.create({
        trigger: section,
        start: 'top bottom+=50%',
        once: true,
        onEnter: attach
      });
    }

    ScrollTrigger.create({
      trigger: section,
      start: 'top top',
      end: 'bottom bottom',
      onUpdate: function (self) { state.target = self.progress; }
    });

    var lastTarget = -1;

    function tick(dt) {
      /* Settled and nothing moved: no work this frame. */
      if (state.target === lastTarget && Math.abs(state.target - state.current) < 1e-4 && !state.dirty) { return; }
      state.dirty = false;

      /* Chase, do not jump: seeking straight to scroll progress stutters. */
      state.current = damp(state.current, state.target, dt);
      var p = state.current;

      if (state.frames) {
        drawFrame(state, p);
      } else if (state.ready && state.duration) {
        var want = p * state.duration;

        var b = video.buffered;
        if (b.length) {
          var end = b.end(b.length - 1);
          if (end > 0) want = Math.min(want, end - 0.01);
        }

        var SEEK_MIN = 1 / 24;
        if (want >= 0 && !video.seeking &&
            Math.abs(video.currentTime - want) > SEEK_MIN) {
          video.currentTime = want;
          state.lastSeek = want;
        } else if (video.seeking) {
          state.dirty = true;               /* retry once the decoder frees up */
        }
      }

      if (state.target === lastTarget) { return; }
      lastTarget = state.target;

      if (bar) bar.style.transform = 'scaleX(' + state.target.toFixed(4) + ')';

      /* Beats hand off on the SCROLLBAR position, not the eased film
         position — copy that lags behind the scroll reads as broken. */
      if (beats.length) {
        var i = 0;
        for (var b = 0; b < beats.length; b++) {
          if (state.target >= parseFloat(beats[b].getAttribute('data-gx-at'))) i = b;
        }
        if (i !== state.live) {
          beats.forEach(function (el, n) { el.classList.toggle('is-live', n === i); });
          state.live = i;
        }
      }

      for (var c = 0; c < callouts.length; c++) {
        var on = state.target >= calloutAt[c];
        if (on !== calloutOn[c]) { calloutOn[c] = on; callouts[c].classList.toggle('is-live', on); }
      }
    }

    return {
      tick: tick,
      progress: function () { return state.target; },
      video: function () { return state.frames ? null : video; }
    };
  }

  /* sequence */

  function loadSequence(base, count, video, canvas, state) {
    if (!canvas) return;

    var el = document.querySelector('[data-gx-seq-urls="' + base + '"]');
    var urls = null;
    if (el) { try { urls = JSON.parse(el.textContent); } catch (e) { urls = null; } }
    if (!urls || !urls.length) { return; }

    var imgs = new Array(count);
    for (var i = 1; i <= count && i <= urls.length; i++) {
      var img = new Image();
      img.decoding = 'async';
      img.src = urls[i - 1];
      imgs[i - 1] = img;
    }

    /* Swap to the canvas only once the first frame is real, so there is
       never a blank rectangle where the poster used to be. */
    imgs[0].addEventListener('load', function () {
      canvas.hidden = false;
      video.hidden = true;
      state.frames = imgs;
      state.ctx = canvas.getContext('2d');
      size(canvas);
      state.drawn = -1;
      drawFrame(state, state.current);
    });

    window.addEventListener('resize', function () {
      if (state.frames) { size(canvas); state.drawn = -1; drawFrame(state, state.current); }
    }, { passive: true });
  }

  function size(canvas) {
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = Math.round(canvas.clientWidth * dpr);
    canvas.height = Math.round(canvas.clientHeight * dpr);
  }

  /* object-fit: cover, by hand — canvas has no such property. */
  function drawFrame(state, p) {
    var frames = state.frames, ctx = state.ctx;
    if (!frames || !ctx) return;

    var i = Math.min(frames.length - 1, Math.max(0, Math.round(p * (frames.length - 1))));
    if (i === state.drawn) return;          /* same frame: skip the full-canvas redraw */
    var img = frames[i];
    if (!img || !img.complete || !img.naturalWidth) { state.dirty = true; return; }
    state.drawn = i;

    var cw = ctx.canvas.width, ch = ctx.canvas.height;
    var scale = Math.max(cw / img.naturalWidth, ch / img.naturalHeight);
    var w = img.naturalWidth * scale, h = img.naturalHeight * scale;
    ctx.drawImage(img, (cw - w) / 2, (ch - h) / 2, w, h);
  }

  /* reveals */

  function reveals() {
    if (reduced.matches) return;

    var groups = [
      /* [selector, kind, stagger ms, cap] */
      ['.gx-section .gx-h2', 'display', 0, 1],
      ['.gx-sec-head__note', 'rise', 0, 1],
      ['.gx-spec__row', 'rise', 45, 8],
      ['.gx-claim', 'rise', 40, 8],
      ['.gx-step', 'rise', 60, 4],
      ['.gx-trust__item', 'rise', 45, 5],
      ['.gx-plate__cell', 'rise', 50, 4],
      ['.gx-rail__acts, .gx-rail > div', 'rise', 0, 1],
      ['.gx-buy__media, .gx-buy__panel', 'rise', 80, 2]
    ];

    groups.forEach(function (g) {
      var els = [].slice.call(document.querySelectorAll(g[0]));
      els.forEach(function (el, i) {
        /* The hero's plate is owned by the entrance; do not double-book it. */
        if (el.closest('.gx-platebar')) return;
        el.setAttribute('data-gx-reveal', g[1] === 'display' ? 'display' : '');
        /* Stagger is capped so a long list never turns into a queue the
           reader waits through. */
        var d = Math.min(i, g[3] - 1) * g[2];
        if (d) { el.style.setProperty('--gx-reveal-delay', d + 'ms'); }

        ScrollTrigger.create({
          trigger: el,
          start: 'top bottom-=12%',
          once: true,
          onEnter: function () { el.classList.add('is-in'); }
        });
      });
    });
  }

  /* line */

  function theLine() {
    var sec = document.querySelector('[data-gx-line]');
    if (!sec) return;

    var path = sec.querySelector('[data-gx-line-path]');
    var nodes = [].slice.call(sec.querySelectorAll('[data-gx-node]'));
    var heads = [].slice.call(sec.querySelectorAll('[data-gx-line-head]'));
    var val = sec.querySelector('[data-gx-line-val]');
    var stage = sec.querySelector('[data-gx-line-stage]');
    if (!path || !nodes.length) return;

    /* Read the tier values off the node labels so this stays in step with
       whatever the generator produced. */
    var mils = nodes.map(function (n) {
      var m = /(\d+)/.exec(n.textContent || '');
      return m ? m[1] : '';
    });

    var len = path.getTotalLength();
    path.style.strokeDasharray = len;
    path.style.strokeDashoffset = len;

    var n = nodes.length;
    var stops = nodes.map(function (_, i) {
      return n > 1 ? 0.10 + i * (0.74 / (n - 1)) : 0.5;
    });

    var state = { target: 0, current: 0, live: null };

    ScrollTrigger.create({
      trigger: sec,
      start: 'top top',
      end: 'bottom bottom',
      onUpdate: function (self) { state.target = self.progress; }
    });

    gsap.ticker.add(function (time, dt) {
      if (Math.abs(state.target - state.current) < 1e-4 && state.live !== null) { return; }
      state.current = damp(state.current, state.target, dt);
      path.style.strokeDashoffset = len * (1 - state.current);

      /* A node lights once the drawn line (not the scrollbar) reaches it. */
      var passed = -1;
      for (var i = 0; i < stops.length; i++) {
        if (state.current >= stops[i]) { passed = i; }
      }

      if (passed !== state.live) {
        nodes.forEach(function (el, i) { el.classList.toggle('is-passed', i <= passed); });
        state.live = passed;
        var i = Math.max(0, passed);
        heads.forEach(function (h, n) { h.classList.toggle('is-live', n === i); });
        if (val) {

          var next = mils[i] || '';
          if (val.textContent !== next) {
            val.style.transition = 'none';
            val.style.transform = 'translateY(-0.42em)';
            val.style.opacity = '0';
            val.textContent = next;
            requestAnimationFrame(function () {
              val.style.transition = 'transform 320ms cubic-bezier(.16,1,.3,1),' +
                                     ' opacity 320ms cubic-bezier(.16,1,.3,1)';
              val.style.transform = '';
              val.style.opacity = '';
            });
          }
        }
        if (stage) {
          stage.textContent = 'Stage 0' + (i + 1) + ' / ' + (mils[i] || '') + ' mil';
        }
      }
    });
  }

  /* rail */

  function rail() {

    var scope = document.querySelector('#main, #MainContent');
    var sections = scope ? [].slice.call(scope.querySelectorAll(
      ':scope > section[id], :scope > [data-gx-act][id],' +
      ':scope > .shopify-section > section[id],' +
      ':scope > .shopify-section > [data-gx-act][id]')) : [];
    if (sections.length < 4) return;

    var nav = document.createElement('nav');
    nav.className = 'gx-rail-nav';
    nav.setAttribute('aria-label', 'Section');

    sections.forEach(function (sec) {
      /* Name it from the section's own heading. A rail that has to be
         captioned by hand is a rail that goes stale. */
      var h = sec.querySelector('h1, h2');
      var name = (h ? h.textContent : sec.id).trim().replace(/\s+/g, ' ');
      if (name.length > 22) { name = name.slice(0, 21).trim() + '\u2026'; }

      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'gx-rail-nav__item';
      b.innerHTML = '<span class="gx-rail-nav__label"></span><span class="gx-rail-nav__tick"></span>';
      b.firstChild.textContent = name;
      b.addEventListener('click', function () {
        /* Through Lenis, never window.scrollTo — Lenis owns the scroll
           position and would drag the page back to its own target. */
        if (window.gripxxLenis) { window.gripxxLenis.scrollTo(sec, { offset: -1 }); }
        else { sec.scrollIntoView(); }
      });
      nav.appendChild(b);

      /* Marks the section that owns the middle of the viewport, so the
         current dot changes at the moment the reader would say it did. */
      ScrollTrigger.create({
        trigger: sec,
        start: 'top center',
        end: 'bottom center',
        onToggle: function (self) {
          b.setAttribute('aria-current', self.isActive ? 'true' : 'false');
        }
      });
    });

    document.body.appendChild(nav);
  }

  /* buy bar */

  function buyBar() {
    var bar = document.querySelector('[data-gx-bar]');
    var firstAct = document.querySelector('[data-gx-act]');
    var range = document.querySelector('#gx-range');
    if (!bar || !firstAct) return;

    ScrollTrigger.create({
      trigger: firstAct,
      start: 'bottom bottom',

      endTrigger: range || document.body,
      end: 'top center',
      onToggle: function (self) { bar.classList.toggle('is-up', self.isActive); }
    });
  }

  /* seams */

  /* weight */

  function magnetic() {
    if (reduced.matches) return;
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    var MAX = 6;
    [].slice.call(document.querySelectorAll('.gx-buy .gx-btn, [data-gx-bar] .gx-btn'))
      .forEach(function (btn) {
        btn.setAttribute('data-gx-magnetic', '');
        btn.addEventListener('pointermove', function (e) {
          var r = btn.getBoundingClientRect();
          var dx = (e.clientX - (r.left + r.width / 2)) / (r.width / 2);
          var dy = (e.clientY - (r.top + r.height / 2)) / (r.height / 2);
          btn.style.transform = 'translate(' + (dx * MAX).toFixed(2) + 'px,' +
                                               (dy * MAX).toFixed(2) + 'px)';
        });
        btn.addEventListener('pointerleave', function () { btn.style.transform = ''; });
      });
  }

  boot();
}());

/* ROUND 3 · WHAT THE TEXTURE DOES — state switching */
(function () {
  'use strict';

  var root = document.querySelector('[data-gxt]');
  if (!root) { return; }

  var opts = Array.prototype.slice.call(root.querySelectorAll('[data-gxt-opt]'));
  if (!opts.length) { return; }

  var svg = root.querySelector('.gxt__svg');
  var cap = root.querySelector('[data-gxt-cap]');
  var note = root.querySelector('[data-gxt-note]');   /* tablet/phone caption */

  var READS = {
    air:   'Section through the 8 mil wall — air moves under the peaks, between the glove and the skin.',
    water: 'Section through the 8 mil wall — liquid runs the valleys and leaves at the shoulder.',
    grip:  'Section through the 8 mil wall — a tool bears on the raised diamonds, not on a flat surface.'
  };
  var SHORT = { air: 'air', water: 'water', grip: 'grip' };

  function select(key, focus) {
    if (!READS[key]) { return; }
    root.setAttribute('data-gxt-state', key);
    opts.forEach(function (b) {
      var on = b.dataset.gxtOpt === key;
      b.setAttribute('aria-selected', on ? 'true' : 'false');
      /* Roving tabindex: one stop for the whole group, arrows move
         inside it — the tablist pattern this markup claims. */
      b.setAttribute('tabindex', on ? '0' : '-1');
      if (on && focus) { b.focus(); }
    });
    if (svg) { svg.setAttribute('aria-label', READS[key]); }
    if (cap) { cap.textContent = 'Section through the 8 mil wall — ' + SHORT[key]; }
    var sel = root.querySelector('[aria-selected="true"] .gxt__note');
    if (note && sel) { note.textContent = sel.textContent; }
  }

  opts.forEach(function (b, i) {
    b.setAttribute('tabindex', b.getAttribute('aria-selected') === 'true' ? '0' : '-1');

    b.addEventListener('click', function () { glideTo(ORDER.indexOf(b.dataset.gxtOpt)); });

    b.addEventListener('keydown', function (e) {
      var step = e.key === 'ArrowDown' || e.key === 'ArrowRight' ? 1
               : e.key === 'ArrowUp'   || e.key === 'ArrowLeft'  ? -1
               : e.key === 'Home' ? -i
               : e.key === 'End'  ? opts.length - 1 - i
               : 0;
      if (!step) { return; }
      e.preventDefault();
      var next = (i + step + opts.length) % opts.length;
      select(opts[next].dataset.gxtOpt, true);
      glideTo(next);
    });
  });

  /* DIRECT MANIPULATION */
  var ORDER = ['air', 'water', 'grip'];
  var LAST  = ORDER.length - 1;

  var cut    = root.querySelector('.gxt__cut');
  var layers = ORDER.map(function (k) { return root.querySelector('.gxt__layer--' + k); });
  var tool   = root.querySelector('.gxt__tool');
  var calls  = root.querySelector('.gxt__calltool');

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  var pos = ORDER.indexOf(root.getAttribute('data-gxt-state') || 'air');
  if (pos < 0) { pos = 0; }
  var vel = 0;            /* states per second */
  var raf = null;
  var target = pos;

  function clamp(n, lo, hi) { return n < lo ? lo : n > hi ? hi : n; }

  function render(p) {
    for (var i = 0; i < layers.length; i++) {
      if (layers[i]) { layers[i].style.opacity = clamp(1 - Math.abs(p - i), 0, 1); }
    }
    /* The tool plane belongs to the grip reading, so it arrives
       with it rather than after it. */
    var g = clamp(1 - Math.abs(p - LAST), 0, 1);
    if (tool)  { tool.style.opacity  = g; }
    if (calls) { calls.style.opacity = g; }
  }

  function commit(i) {
    layers.forEach(function (l) { if (l) { l.style.opacity = ''; } });
    if (tool)  { tool.style.opacity  = ''; }
    if (calls) { calls.style.opacity = ''; }
    root.removeAttribute('data-gxt-scrub');
    select(ORDER[i], false);
  }

  /* Apple's projection, not the textbook v^2/(2a): where a flick
     would come to rest if it decelerated like a scroll. */
  function project(v, rate) {
    rate = rate || 0.998;
    return (v / 1000) * rate / (1 - rate);
  }

  /* Progressive resistance past the ends. A hard stop reads as a
     bug; resistance reads as "there is nothing more this way". */
  function rubberband(overshoot, dim, c) {
    c = c || 0.55;
    return (overshoot * dim * c) / (dim + c * Math.abs(overshoot));
  }

  function bounded(p) {
    if (p < 0)    { return -rubberband(-p, 1); }
    if (p > LAST) { return LAST + rubberband(p - LAST, 1); }
    return p;
  }

  function stopSpring() {
    if (raf) { cancelAnimationFrame(raf); raf = null; }
  }

  function spring(to, v0) {
    stopSpring();
    target = to;
    vel = v0 || 0;
    if (reduce && reduce.matches) { pos = to; render(pos); commit(to); return; }

    var damping = 1.0;
    var response = 0.4;
    var omega = (2 * Math.PI) / response;
    var last = null;

    raf = requestAnimationFrame(function step(now) {
      if (last === null) { last = now; }
      var dt = Math.min((now - last) / 1000, 1 / 30);
      last = now;

      var a = -2 * damping * omega * vel - omega * omega * (pos - target);
      vel += a * dt;
      pos += vel * dt;

      if (Math.abs(pos - target) < 0.004 && Math.abs(vel) < 0.02) {
        pos = target; vel = 0; raf = null;
        render(pos); commit(target);
        return;
      }
      render(pos);
      raf = requestAnimationFrame(step);
    });
  }

  /* Click and keyboard land here too, so every route into a state
     travels the same path and can be interrupted the same way. */
  function glideTo(i) {
    if (i < 0 || i > LAST) { return; }
    root.setAttribute('data-gxt-scrub', '');
    render(pos);
    spring(i, vel);
  }

  if (cut && window.PointerEvent) {
    root.setAttribute('data-gxt-grab', '');

    var unit = 0;         /* px travelled per whole state */
    var startX = 0, startPos = 0;
    var dragging = false, decided = false, pid = null;
    var hist = [];        /* recent {x,t} for a release velocity */

    cut.addEventListener('pointerdown', function (e) {
      if (e.button != null && e.button !== 0) { return; }
      /* Grabbing mid-flight inherits the motion already on screen:
         stop the spring but keep pos and vel exactly as they are. */
      stopSpring();
      dragging = true; decided = false;
      pid = e.pointerId;
      startX = e.clientX;
      startPos = pos;
      hist = [{ x: e.clientX, t: e.timeStamp }];
      unit = Math.max(cut.getBoundingClientRect().width / 2, 1);
      root.setAttribute('data-gxt-scrub', '');
      render(pos);
    });

    cut.addEventListener('pointermove', function (e) {
      if (!dragging || e.pointerId !== pid) { return; }
      var dx = e.clientX - startX;

      /* ~10px of hysteresis before we claim the gesture, so a tap
         and a vertical scroll are never stolen by the scrub. */
      if (!decided) {
        if (Math.abs(dx) < 10) { return; }
        decided = true;
        cut.setPointerCapture(pid);   /* keep tracking outside the box */
      }

      hist.push({ x: e.clientX, t: e.timeStamp });
      if (hist.length > 6) { hist.shift(); }

      /* Dragging right advances toward grip. 1:1 with the pointer,
         measured from where the drag began — never re-centred. */
      pos = bounded(startPos + dx / unit);
      render(pos);
    });

    function release(e) {
      if (!dragging || (pid !== null && e.pointerId !== pid)) { return; }
      dragging = false;
      if (cut.hasPointerCapture && cut.hasPointerCapture(pid)) { cut.releasePointerCapture(pid); }
      pid = null;

      if (!decided) { root.removeAttribute('data-gxt-scrub'); commit(Math.round(clamp(pos, 0, LAST))); return; }

      /* Velocity from the tail of the move history, in states/sec. */
      var v = 0;
      if (hist.length > 1) {
        var a = hist[0], b = hist[hist.length - 1];
        var dt = (b.t - a.t) / 1000;
        if (dt > 0) { v = ((b.x - a.x) / unit) / dt; }
      }

      /* Land where the flick was going, not where the finger left. */
      var land = clamp(Math.round(clamp(pos + project(v), 0, LAST)), 0, LAST);
      spring(land, v);
    }

    cut.addEventListener('pointerup', release);
    cut.addEventListener('pointercancel', release);
  }

  select(root.getAttribute('data-gxt-state') || 'air', false);
}());

/* GRIPXX BUY PANEL */
(function () {
  'use strict';

  [].forEach.call(document.querySelectorAll('[data-gx-buy]'), function (root, n) { initBuy(root, n === 0); });

  function initBuy(root, ownsBar) {
  var sec = root.closest('.gx-section') || document;
  function q(sel) { return sec.querySelector(sel); }
  function all(sel) { return [].slice.call(sec.querySelectorAll(sel)); }

  function readJSON(sel, fallback) {
    var el = q(sel);
    if (!el) { return fallback; }
    try { return JSON.parse(el.textContent); } catch (e) { return fallback; }
  }

  var VARIANTS = readJSON('[data-gx-variants]', null);
  if (!VARIANTS || !VARIANTS.length) { return; }
  var MEDIA = readJSON('[data-gx-media]', []) || [];
  var COLOUR_POS = readJSON('[data-gx-colourpos]', -1);

  var sel     = q('[data-gx-variant]');
  var express = q('[data-gx-express]');
  /* Explains a sold-out or missing combination in the panel's status line. */
  function gxHint(msg) {
    var e = q('[data-gx-err]');
    if (!e) { return; }
    e.textContent = msg;
    e.hidden = !msg;
  }
  function gxNames() {
    var out = [];
    all('[data-gx-group]').forEach(function (g) {
      out[parseInt(g.getAttribute('data-gx-group'), 10)] = g.getAttribute('aria-label') || '';
    });
    return out;
  }
  var priceEl = q('[data-gx-price]');
  var unitEl  = q('[data-gx-unit]');
  var skuEl   = q('[data-gx-sku]');
  var skuWrap = q('[data-gx-sku-wrap]');
  var stockEl = q('[data-gx-stock]');
  var addBtn  = q('[data-gx-add]');
  var errEl   = q('[data-gx-err]');
  var totalEl = q('[data-gx-total]');
  var savEl   = q('[data-gx-saving]');
  var shot    = q('[data-gx-shot]');
  var stage   = q('[data-gx-stage]');
  var countEl = q('[data-gx-count]');
  var specLink = q('[data-gx-spec-link]');
  var form    = q('form');
  var groups  = all('[data-gx-group]');

  var bar      = ownsBar && document.querySelector('[data-gx-bar]');
  var titleEl  = q('[data-gx-title]');
  var baseTitle = titleEl && titleEl.textContent.trim();
  var barId    = bar && bar.querySelector('[data-gx-bar-id]');
  var barPrice = bar && bar.querySelector('[data-gx-bar-price]');
  var barUnit  = bar && bar.querySelector('[data-gx-bar-unit]');
  var barAdd   = bar && bar.querySelector('[data-gx-bar-add]');
  var barForm  = barAdd && barAdd.form;

  function label(el, key, fallback) {
    return (el && el.getAttribute(key)) || fallback;
  }

  /* Currency from whatever Liquid rendered, so a euro store stays euro. */
  var PRE = '$', SUF = '';
  (function () {
    if (!priceEl) { return; }
    var first = priceEl.firstChild;
    var txt = first && first.nodeType === 3 ? first.nodeValue.trim() : priceEl.textContent.trim();
    var m = txt.match(/^([^\d]*)[\d.,\s]+(.*)$/);
    if (m) { PRE = m[1]; SUF = m[2]; }
  }());

  function money(cents) {
    var n = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return PRE + n + SUF;
  }

  /* selection */

  /* Read from the markup, so first paint and the script cannot disagree. */
  function chosen() {
    var out = [];
    groups.forEach(function (g) {
      var i = parseInt(g.getAttribute('data-gx-group'), 10);
      var on = g.querySelector('[aria-checked="true"]');
      out[i] = on ? on.getAttribute('data-gx-val') : null;
    });
    return out;
  }

  /* Prefers an available variant when the options do not pin one down. */
  function match(want, availableOnly) {
    var fallback = null;
    for (var i = 0; i < VARIANTS.length; i++) {
      var v = VARIANTS[i], ok = true;
      for (var j = 0; j < want.length; j++) {
        if (want[j] != null && v.options[j] !== want[j]) { ok = false; break; }
      }
      if (!ok) { continue; }
      if (v.available) { return v; }
      if (!fallback) { fallback = v; }
    }
    return availableOnly ? null : fallback;
  }

  /* Hold the pressed value, relax the others until a real variant appears. */
  function repair(pos, value) {
    var want = chosen();
    want[pos] = value;
    if (match(want, false)) { return want; }

    for (var k = 0; k < want.length; k++) {
      if (k === pos) { continue; }
      var trial = want.slice();
      trial[k] = null;
      var v = match(trial, false);
      if (v) { return v.options.slice(0, want.length); }
    }
    var any = null;
    for (var i = 0; i < VARIANTS.length; i++) {
      if (VARIANTS[i].options[pos] === value) { any = VARIANTS[i]; break; }
    }
    return any ? any.options.slice(0, want.length) : want;
  }

  function apply(want) {
    groups.forEach(function (g) {
      var i = parseInt(g.getAttribute('data-gx-group'), 10);
      [].slice.call(g.querySelectorAll('[data-gx-val]')).forEach(function (b) {
        var on = b.getAttribute('data-gx-val') === want[i];
        b.setAttribute('aria-checked', String(on));
        b.tabIndex = on ? 0 : -1;
      });
      var out = sec.querySelector('[data-gx-chosen="' + i + '"]');
      if (out) { out.textContent = want[i] || ''; }
    });
  }

  /* Marked, not disabled: pressing one is how you reach its combination. */
  function markAvailability(want) {
    groups.forEach(function (g) {
      var i = parseInt(g.getAttribute('data-gx-group'), 10);
      [].slice.call(g.querySelectorAll('[data-gx-val]')).forEach(function (b) {
        var trial = want.slice();
        trial[i] = b.getAttribute('data-gx-val');
        var live = match(trial, true);
        b.classList.toggle('is-off', !live);
        if (!live) { b.setAttribute('data-gx-unavailable', ''); }
        else { b.removeAttribute('data-gx-unavailable'); }
      });
    });
  }

  /* gallery */

  /* This colour's images, or all of them when it has none of its own. */
  var view = [];   /* indices into MEDIA */
  var at = 0;
  var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  function galleryFor(colour) {
    var mine = [];
    if (colour) {
      for (var i = 0; i < MEDIA.length; i++) {
        if (MEDIA[i].colour && MEDIA[i].colour.toLowerCase() === colour.toLowerCase()) { mine.push(i); }
      }
    }
    if (mine.length) { return mine; }
    return MEDIA.map(function (_, i) { return i; });
  }

  function show(n, animate) {
    if (!view.length || !shot) { return; }
    at = (n % view.length + view.length) % view.length;
    var item = MEDIA[view[at]];
    if (!item) { return; }

    if (animate && !(still && still.matches) && shot.getAttribute('src') !== item.src) {
      shot.classList.add('is-swapping');
      var done = function () {
        shot.src = item.src;
        shot.alt = item.alt || '';
        requestAnimationFrame(function () { shot.classList.remove('is-swapping'); });
      };
      /* The timeout owns the swap, so a missed transition cannot strand it. */
      setTimeout(done, 180);
    } else {
      shot.src = item.src;
      shot.alt = item.alt || '';
    }

    all('[data-gx-thumb]').forEach(function (t) {
      var idx = parseInt(t.getAttribute('data-gx-thumb'), 10);
      t.setAttribute('aria-pressed', String(idx === view[at]));
    });

    if (countEl) {
      countEl.hidden = view.length < 2;
      countEl.textContent = (at + 1) + ' / ' + view.length;
    }
    all('[data-gx-step]').forEach(function (b) { b.hidden = view.length < 2; });
  }

  /* Hides the other colours' thumbnails; all of them are in the markup. */
  function setGallery(colour, preferSrc) {
    /* No media data: leave the thumbnails alone rather than hide them all. */
    if (!MEDIA.length) { return; }

    view = galleryFor(colour);

    all('[data-gx-thumb]').forEach(function (t) {
      var idx = parseInt(t.getAttribute('data-gx-thumb'), 10);
      t.hidden = view.indexOf(idx) < 0;
    });

    var start = 0;
    if (preferSrc) {
      for (var i = 0; i < view.length; i++) {
        if (MEDIA[view[i]].src === preferSrc) { start = i; break; }
      }
    }
    show(start, false);
  }

  /* paint */

  function paint(want, moveGallery) {
    var v = match(want, false);

    if (errEl) { errEl.hidden = true; }

    if (!v) {
      if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = label(addBtn, 'data-label-gone', 'Not sold in that combination');
      }
      if (barAdd) { barAdd.disabled = true; }
      if (express) { express.hidden = true; }
      gxHint('That combination isn\'t sold. Choose another option.');
      markAvailability(want);
      return;
    }
    if (!v.available && window.LLVariantHint) {
      gxHint(window.LLVariantHint.soldOut(VARIANTS, v.options, gxNames()));
    }

    if (sel && sel.value !== String(v.id)) {
      sel.value = String(v.id);
      /* Express checkout buttons read the chosen variant from this field. */
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (express) { express.hidden = !v.available; }

    if (priceEl) {
      var html = money(v.price);
      if (v.compare_at_price > v.price) {
        html += '<span class="gx-price__was">' + money(v.compare_at_price) + '</span>';
      }
      priceEl.innerHTML = html;
    }
    if (unitEl) { unitEl.textContent = v.title === 'Default Title' ? '' : v.title; }
    if (skuEl)  { skuEl.textContent = v.sku || ''; }
    if (skuWrap) { skuWrap.hidden = !v.sku; }

    if (addBtn) {
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available
        ? label(addBtn, 'data-label-add', 'Add the case')
        : label(addBtn, 'data-label-sold', 'Sold out');
    }
    if (stockEl) {
      stockEl.textContent = v.available
        ? (stockEl.getAttribute('data-in') || '')
        : (stockEl.getAttribute('data-out') || '');
    }

    var pct = v.compare_at_price > v.price
      ? Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) : 0;
    if (totalEl) { totalEl.hidden = pct === 0; }
    if (savEl)   { savEl.textContent = pct + '% off'; }

    if (barId)    { barId.value = String(v.id); }
    if (barPrice) { barPrice.textContent = money(v.price); }
    if (barUnit)  { barUnit.textContent = v.title === 'Default Title' ? '' : v.title; }
    if (barAdd) {
      barAdd.disabled = !v.available;
      barAdd.textContent = v.available
        ? label(barAdd, 'data-label-add', 'Add the case')
        : label(barAdd, 'data-label-sold', 'Sold out');
    }

    if (moveGallery) {
      setGallery(COLOUR_POS > -1 ? v.options[COLOUR_POS] : '', v.image);
    }

    /* Shareable URL, no history entry per click. */
    if (specLink) {
      specLink.href = (v.url || specLink.href.split('?')[0]) + '?variant=' + v.id;
    }
    /* Grouped colours are separate products: follow the title unless the
       editor overrode it (then it never matched the first product's). */
    if (titleEl && v.ptitle && baseTitle === titleEl.getAttribute('data-gx-ptitle')) {
      titleEl.textContent = v.ptitle;
    }
    if (booted) {
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', u);
      } catch (e) {}
    }

    markAvailability(want);
  }

  /* wire */

  groups.forEach(function (g) {
    var pos = parseInt(g.getAttribute('data-gx-group'), 10);
    var btns = [].slice.call(g.querySelectorAll('[data-gx-val]'));

    btns.forEach(function (b, i) {
      b.tabIndex = b.getAttribute('aria-checked') === 'true' ? 0 : -1;

      b.addEventListener('click', function () {
        var want = repair(pos, b.getAttribute('data-gx-val'));
        apply(want);
        paint(want, true);
      });

      /* Roving tabindex, as a radiogroup owes the keyboard. */
      b.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1
              : e.key === 'ArrowLeft'  || e.key === 'ArrowUp'   ? -1 : 0;
        if (!d) { return; }
        e.preventDefault();
        var next = btns[(i + d + btns.length) % btns.length];
        var want = repair(pos, next.getAttribute('data-gx-val'));
        apply(want);
        paint(want, true);
        next.focus();
      });
    });
  });

  all('[data-gx-thumb]').forEach(function (t) {
    t.addEventListener('click', function () {
      var idx = parseInt(t.getAttribute('data-gx-thumb'), 10);
      var n = view.indexOf(idx);
      if (n > -1) { show(n, true); }
    });
  });

  all('[data-gx-step]').forEach(function (b) {
    b.addEventListener('click', function () {
      show(at + parseInt(b.getAttribute('data-gx-step'), 10), true);
    });
  });

  /* Only while the gallery has focus, or this breaks page scrolling. */
  if (stage) {
    stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { e.preventDefault(); show(at - 1, true); }
      if (e.key === 'ArrowRight') { e.preventDefault(); show(at + 1, true); }
    });
  }

  /* add to cart */

  /* One path for both buttons: same line in the cart, same failure. */
  function addToCart(theForm, btn) {
    var v = match(chosen(), false);
    if (!v || !v.available) { return; }

    var qtyEl = theForm.querySelector('[name="quantity"]');
    var qty = Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1);
    var back = btn.textContent;
    btn.disabled = true;
    btn.textContent = label(btn, 'data-label-busy', 'Adding…');
    if (errEl) { errEl.hidden = true; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: v.id, quantity: qty }] })
    }).then(function (r) {
      return r.json().then(function (body) { return { ok: r.ok, body: body }; });
    }).then(function (res) {
      if (!res.ok) {
        /* Shopify refused — usually stock. A message to read, not a redirect. */
        var refusal = new Error((res.body && res.body.description) || 'Could not add to cart');
        refusal.answered = true;
        throw refusal;
      }

      btn.disabled = false;
      btn.textContent = label(btn, 'data-label-done', 'Added to cart');
      setTimeout(function () { btn.textContent = back; }, 2000);

      /* custom-system.js re-reads /cart.js on this event; open the drawer
         a beat later so it paints the line just added. */
      document.dispatchEvent(new CustomEvent('cart:changed', { bubbles: true }));
      var open = document.querySelector('[data-open-cart]');
      if (open) { setTimeout(function () { open.click(); }, 160); }
    }).catch(function (err) {
      btn.disabled = false;
      btn.textContent = back;
      if (errEl) {
        errEl.textContent = err.message;
        errEl.hidden = false;
      }
      /* A broken request falls back to the ordinary POST; a refusal stays. */
      if (!err.answered) { theForm.submit(); }
    });
  }

  function intercept(theForm, btn) {
    if (!theForm || !btn) { return; }
    theForm.addEventListener('submit', function (e) {
      if (!window.fetch) { return; }          /* let the native POST happen */
      e.preventDefault();
      addToCart(theForm, btn);
    });
  }

  intercept(form, addBtn);
  intercept(barForm, barAdd);

  /* First paint: deep link, markup and gallery agree before any click. */
  var booted = false;
  var want0 = chosen();
  apply(want0);
  paint(want0, true);
  booted = true;
  }
}());
